const local = {
  API: {
    AUTH: 'https://localhost:7097/api',
    DATA: 'https://localhost:7097/api'
  },
  CHAT: 'https://localhost:7097/chat'
}

const dev = {
  API: {
    AUTH: 'https://localhost:7097/api',
    DATA: 'https://localhost:7097/api'
  },
  CHAT: 'https://localhost:7097/chat'
}

const uat = {
  API: {
    AUTH: 'https://coillte-ebs-api-uat.azurewebsites.net/api',
    DATA: 'https://coillte-ebs-api-uat.azurewebsites.net/api'
  },
  CHAT: 'https://localhost:7097/chat'
}

const prod = {
  API: {
    AUTH: 'https://coillte-ebs-api.azurewebsites.net/api',
    DATA: 'https://coillte-ebs-api.azurewebsites.net/api'
  },
  CHAT: 'https://localhost:7091/chat'
}

const config = process.env.REACT_APP_STAGE === 'prod' ? prod
  : process.env.REACT_APP_STAGE === 'uat' ? uat
    : process.env.REACT_APP_STAGE === 'dev' ? dev
      : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;

export { API_URL, AUTH_URL };
export default config;
